import { formatCurrency } from 'utils';

export type PositionsStatus = 'loading' | 'error' | 'ready';

export const getPositionsStatus = (
    query: { isPending: boolean; isLoadingError: boolean },
    hasBrokerAccounts: boolean,
): PositionsStatus => {
    if (!hasBrokerAccounts) return 'ready';
    if (query.isLoadingError) return 'error';
    return query.isPending ? 'loading' : 'ready';
};

export const PositionAmount = ({ value, status }: { value?: number; status: PositionsStatus }) => (
    <>{value === undefined ? (status === 'error' ? 'Unavailable' : 'Loading…') : formatCurrency(value)}</>
);
